import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { TooltipModule } from 'ngx-tooltip';
import { FullCalendarModule } from 'ng-fullcalendar';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PasswordStrengthBarModule } from 'ng2-password-strength-bar';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxPermissionsModule } from 'ngx-permissions';
import { DxDateBoxModule, DxDataGridModule, DxSelectBoxModule, DxCheckBoxModule, DxTabsModule, DxFormModule, DxTreeViewModule } from 'devextreme-angular';
import {
	MatSlideToggleModule,
	MatSelectModule,
	MatRadioModule,
	MatAutocompleteModule,
	MatFormFieldModule,
	MatNativeDateModule,
	MatInputModule,
	MatProgressBarModule,
	MatIconModule,
	MatCheckboxModule,
	MatButtonModule,
	MatTabsModule,
	MatButtonToggleModule,
	MatDialogModule,
	MatExpansionModule

} from '@angular/material';
import { MatStepperModule } from '@angular/material/stepper';
import { ShowErrorsComponent } from '../directives';
import { MyDateRangePickerModule } from 'mydaterangepicker';
import { TreeviewModule } from 'ngx-treeview';
import { EmailValidatorDirective } from '@app/directives/email-validator.directive';
import { AuthService } from '@app/services/auth.service';

@NgModule({
	declarations: [ShowErrorsComponent, EmailValidatorDirective],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		BrowserAnimationsModule,
		NgxPermissionsModule.forRoot(),
		DxDateBoxModule,
		DxDataGridModule,
		DxSelectBoxModule,
		DxCheckBoxModule,
		DxTabsModule,
		TreeviewModule.forRoot(),
	],
	exports: [
		CurrencyMaskModule,
		MatSlideToggleModule,
		MatSelectModule,
		MatRadioModule,
		MatAutocompleteModule,
		MatFormFieldModule,
		MatNativeDateModule,
		MatInputModule,
		MatProgressBarModule,
		MatIconModule,
		MatCheckboxModule,
		MatButtonModule,
		MatTabsModule,
		MatButtonToggleModule,
		MatStepperModule,
		TooltipModule,
		PasswordStrengthBarModule,
		FullCalendarModule,
		NgxPermissionsModule,
		ShowErrorsComponent,
		NgSelectModule,
		MyDateRangePickerModule,
		DxDateBoxModule,
		DxDataGridModule,
		DxSelectBoxModule,
		DxCheckBoxModule,
		DxTabsModule,
		DxFormModule,
		DxTreeViewModule,
		TreeviewModule,
		EmailValidatorDirective,
		MatExpansionModule
	],
	providers: [CurrencyPipe, AuthService]
})
export class SharedModule { }
